// extracted by mini-css-extract-plugin
export var heading1 = "heading-level-module--heading1--A3P-A";
export var heading2 = "heading-level-module--heading2--XloNi";
export var heading3 = "heading-level-module--heading3--kyG3E";
export var heading4 = "heading-level-module--heading4--ka832";
export var heading5 = "heading-level-module--heading5--UfMSd";
export var headingSpan = "heading-level-module--heading-span--D4SJq";